export default __webpack_public_path__ + "static/media/angle-double-left.93872fa6.svg";